import React, { useState, useRef, useEffect, useContext } from "react";
import "./navbar.css";
import { FaUserCircle } from "react-icons/fa";
import { FaShoppingCart } from "react-icons/fa";
import { AuthContext } from "../../context/AuthContext";
import { CartContext } from "../../context/CartContext"; // ← تأكد من وجوده

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [addMenuOpen, setAddMenuOpen] = useState(false);
  const [invoiceMenuOpen, setInvoiceMenuOpen] = useState(false);
  const [voucherMenuOpen, setVoucherMenuOpen] = useState(false);
  const [statementMenuOpen, setStatementMenuOpen] = useState(false);
  const menuRef = useRef();
  const addMenuRef = useRef();
  const invoiceMenuRef = useRef();
  const voucherMenuRef = useRef();
  const statementMenuRef = useRef();
  const { user, logout } = useContext(AuthContext);
  const { cartCount, getCartCount } = useContext(CartContext); // ← عدد العناصر في السلة

  useEffect(() => {
    getCartCount();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      // Check if click is outside user menu
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }

      // Check if click is outside add menu
      if (addMenuRef.current && !addMenuRef.current.contains(e.target)) {
        setAddMenuOpen(false);
      }

      // Check if click is outside invoice menu
      if (
        invoiceMenuRef.current &&
        !invoiceMenuRef.current.contains(e.target)
      ) {
        setInvoiceMenuOpen(false);
      }

      // Check if click is outside voucher menu
      if (
        voucherMenuRef.current &&
        !voucherMenuRef.current.contains(e.target)
      ) {
        setVoucherMenuOpen(false);
      }

      // Check if click is outside statement menu
      if (
        statementMenuRef.current &&
        !statementMenuRef.current.contains(e.target)
      ) {
        setStatementMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="wrapper">
        <div href="/" className="navbar-right">
          <img
            src="/assets/logo_ashour.png"
            alt="Logo"
            className="navbar-logo"
          />
          <ul className="navbar-links">
            <li>
              <a href="/">الرئيسية</a>
            </li>
            <li>
              <a href="/products">الاصناف</a>
            </li>
            <li>
              <a href="/shelves">الرفوف</a>
            </li>
            <li>
              <a href="/customers">الزبائن</a>
            </li>
            <li>
              <a href="/suppliers">الموردين</a>
            </li>
            <li>
              <a href="/barcode-entry">إدخال باركود</a>
            </li>
            <li>
              <a href="/debts">الذمم</a>
            </li>
            <li className="dropdown" ref={statementMenuRef}>
              <span
                className="dropdown-toggle"
                onClick={() => {
                  setStatementMenuOpen((prev) => !prev);
                  setInvoiceMenuOpen(false);
                  setVoucherMenuOpen(false);
                  setAddMenuOpen(false);
                }}
              >
                الكشفوات ▼
              </span>
              {statementMenuOpen && (
                <div className="dropdown-menu">
                  <a href="/customer-statement" className="dropdown-item">
                    كشف حساب زبون
                  </a>
                  <a href="/supplier-statement" className="dropdown-item">
                    كشف حساب مورد
                  </a>
                </div>
              )}
            </li>
            <li className="dropdown" ref={invoiceMenuRef}>
              <span
                className="dropdown-toggle"
                onClick={() => {
                  setInvoiceMenuOpen((prev) => !prev);
                  setAddMenuOpen(false);
                  setVoucherMenuOpen(false);
                  setStatementMenuOpen(false);
                }}
              >
                الفواتير ▼
              </span>
              {invoiceMenuOpen && (
                <div className="dropdown-menu">
                  <a href="/purchase-invoices" className="dropdown-item">
                    فواتير الشراء
                  </a>
                  <a href="/sales-invoices" className="dropdown-item">
                    فواتير البيع
                  </a>
                  <a href="/returned-invoices" className="dropdown-item">
                    الفواتير المرتجعة
                  </a>
                  <a href="/expense-invoices" className="dropdown-item">
                    فواتير الصرف
                  </a>
                  <a href="/new-purchase-invoice" className="dropdown-item">
                    إضافة فاتورة شراء
                  </a>
                  <a href="/cart" className="dropdown-item">
                    إضافة فاتورة بيع
                  </a>{" "}
                  <a href="/expense-invoice/new" className="dropdown-item">
                    إضافة فاتورة صرف
                  </a>
                </div>
              )}
            </li>
            <li className="dropdown" ref={voucherMenuRef}>
              <span
                className="dropdown-toggle"
                onClick={() => {
                  setVoucherMenuOpen((prev) => !prev);
                  setInvoiceMenuOpen(false);
                  setAddMenuOpen(false);
                  setStatementMenuOpen(false);
                }}
              >
                السندات ▼
              </span>
              {voucherMenuOpen && (
                <div className="dropdown-menu">
                  <a href="/receipt-vouchers" className="dropdown-item">
                    سندات القبض
                  </a>
                  <a href="/payment-vouchers" className="dropdown-item">
                    سندات الصرف
                  </a>
                  <a href="/new-receipt-voucher" className="dropdown-item">
                    إنشاء سند قبض
                  </a>
                  <a href="/new-payment-voucher" className="dropdown-item">
                    إنشاء سند صرف
                  </a>
                </div>
              )}
            </li>
            <li className="dropdown" ref={addMenuRef}>
              <span
                className="dropdown-toggle"
                onClick={() => {
                  setAddMenuOpen((prev) => !prev);
                  setInvoiceMenuOpen(false);
                  setVoucherMenuOpen(false);
                  setStatementMenuOpen(false);
                }}
              >
                إضافة ▼
              </span>
              {addMenuOpen && (
                <div className="dropdown-menu">
                  <a href="/new-shelf" className="dropdown-item">
                    إضافة رف جديد
                  </a>
                  <a href="/new-product" className="dropdown-item">
                    إضافة صنف جديد
                  </a>
                  <a href="/new-customer" className="dropdown-item">
                    إضافة زبون جديد
                  </a>
                  <a href="/new-supplier" className="dropdown-item">
                    إضافة مورد جديد
                  </a>
                </div>
              )}
            </li>
          </ul>
        </div>

        <div className="navbar-left" ref={menuRef}>
          {/* 🏢 اسم الفرع النشط */}
          {user?.activeBranchName && (
            <span className="branch-badge" title="الفرع الحالي">
              🏢 {user.activeBranchName}
            </span>
          )}

          {/* ✅ أيقونة السلة مع العداد */}
          <a href="/cart" className="cart-icon-wrapper">
            <FaShoppingCart className="cart-icon" />
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
          </a>

          {/* ✅ أيقونة المستخدم */}
          <FaUserCircle
            className="user-icon"
            onClick={() => setMenuOpen((prev) => !prev)}
          />
          {menuOpen && (
            <div className="user-menu">
              <a href="/profile" className="menu-item username profile-link">
                👤 {user?.full_name || "مستخدم"}
              </a>
              <button className="menu-item logout" onClick={logout}>
                تسجيل خروج
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
